import { SuccessAlert, ErrorAlert } from "components/atoms/Alert"
import { Button, LinkButton } from "components/atoms/Button"
import { AuthFormItem, AuthForm } from "components/atoms/form"
import { useFirebaseLogOut } from "hooks/useFirebaseLogOut"
import { useAsyncLoading } from "hooks/useLoading"
import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { firebaseUserState } from "recoils/firebaseUserState"
import { sendEmailToVerify, firebaseError } from "usecases/firebase/auth"

export const RegisterEmailPage: React.VFC = () => {
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [errorCode, setErrorCode] = useState("")
  const logOut = useFirebaseLogOut()
  const user = useRecoilValue(firebaseUserState)
  const navigate = useNavigate()
  const [loading, asyncLoading] = useAsyncLoading()
  useEffect(() => {
    user.isAuth && user.emailVerified && navigate("/")
  }, [user])
  return (
    <AuthForm>
      <AuthFormItem>
        以下のメールアドレスに確認メールを送信しました。
        <br />
        {user.email} <br />
        <br />
        続けて登録作業を行うには、
        <br />
        確認メールに添付されたリンクにアクセスしてください。
        <br />
      </AuthFormItem>
      <AuthFormItem>
        <LinkButton onClick={logOut}>
          別のメールアドレスでログインする
        </LinkButton>
      </AuthFormItem>

      {success && (
        <SuccessAlert>メールを再送信しました。ご確認ください。</SuccessAlert>
      )}
      {error && !success && <ErrorAlert>{errorCode}</ErrorAlert>}
      <AuthFormItem>
        <Button
          isLoading={loading}
          onClick={() => {
            asyncLoading(
              sendEmailToVerify()
                .then(() => {
                  setSuccess(true)
                })
                .catch((e) => {
                  setError(true)
                  const mes = firebaseError(e.code)
                  mes && setErrorCode(mes)
                }),
            )
          }}
        >
          もう一度確認メールを送る
        </Button>
      </AuthFormItem>
    </AuthForm>
  )
}
